<template>
  <div>
    <el-aside id="left">
      <el-menu unique-opened :default-active="defaultActive">
        <template v-for="(group) in jsonData">
          <el-submenu :index="group.moduleUrl" v-if="group.children.length>0">
            <template slot="title">
              <i :class="['iconfont','icon-path',group.moduleIcon]"></i>
              {{group.moduleName}}
            </template>
            <template v-for="(item,index2) in group.children">
              <el-menu-item :index="item.moduleUrl" @click="goPath(group,item)">
                <div>{{item.moduleName}}</div>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :index="group.moduleUrl" class="no-child">
            <div @click="goPath({},group)">
              <i :class="['iconfont','icon-path',group.moduleIcon]"></i>
              {{group.moduleName}}
            </div>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-main style="height: 100%;padding: 20px 20px 0;background-color: #eee;">
      <router-view/>
    </el-main>
  </div>
</template>
<script>
  export default {
    inject: ['refresh'],
    props: {},
    data () {
      return {
        defaultActive: '/index',
        jsonData: [],
        /*    jsonData: [
              {
                'children': [],
                'moduleIcon': 'icon-shouye',
                'moduleName': '首页',
                'moduleUrl': '/index',
              }, {
                'children': [{
                  'children': [],
                  'moduleIcon': 'account_settings',
                  'moduleName': '行业管理',
                  'moduleUrl': '/base_data/trade_manage',
                }, {
                  'children': [],
                  'moduleIcon': 'security_log',
                  'moduleName': '类目模板',
                  'moduleUrl': '/base_data/category_manage',
                }, {
                  'children': [],
                  'moduleIcon': 'security_log',
                  'moduleName': '会员属性',
                  'moduleUrl': '/base_data/member_attribute',
                }, {
                  'children': [],
                  'moduleIcon': 'security_log',
                  'moduleName': '会员模版',
                  'moduleUrl': '/base_data/member_template',
                }, {
                  'children': [],
                  'moduleIcon': 'security_log',
                  'moduleName': '规格属性管理',
                  'moduleUrl': '/base_data/size_manage',
                }],
                'moduleIcon': 'icon-jichushezhi1',
                'moduleName': '基础数据',
                'moduleUrl': '/base_data',
              }, {
                'children': [{
                  'children': [],
                  'moduleIcon': 'industry_management',
                  'moduleName': '商家管理',
                  'moduleUrl': '/shop_manage/merchant_manage',
                }, {
                  'children': [],
                  'moduleIcon': 'category_management',
                  'moduleName': '门店管理',
                  'moduleUrl': '/shop_manage/store_manage',
                }, {
                  'children': [],
                  'moduleIcon': '1',
                  'moduleName': '用户管理',
                  'moduleUrl': '/shop_manage/user',
                }, {
                  'children': [],
                  'moduleIcon': '1',
                  'moduleName': '代理推广用户',
                  'moduleUrl': '/shop_manage/agentUser',
                }, {
                  'children': [],
                  'moduleIcon': '1',
                  'moduleName': '代理商管理',
                  'moduleUrl': '/shop_manage/agentManage',
                }],
                'moduleIcon': 'icon-shanghuguanli2',
                'moduleName': '商户管理',
                'moduleUrl': '/shop_manage',
              }, {
                'children': [{
                  'children': [],
                  'moduleIcon': 'icon-fenxibaobiao1',
                  'moduleName': '体验账号统计',
                  'moduleUrl': '/marketingManage/experience_info',
                },
                  {
                    'children': [],
                    'moduleIcon': 'product',
                    'moduleName': '产品定价',
                    'moduleUrl': '/marketingManage/product',
                  }, {
                    'children': [],
                    'moduleIcon': 'loginAward',
                    'moduleName': '产品版本管理',
                    'moduleUrl': '/marketingManage/versionManage',
                  }, {
                    'children': [],
                    'moduleIcon': 'loginAward',
                    'moduleName': '功能体验配置',
                    'moduleUrl': '/marketingManage/experienceConfig',
                  }, {
                    'children': [],
                    'moduleIcon': 'bannerManage',
                    'moduleName': '评分配置',
                    'moduleUrl': '/marketingManage/gradeConfig',
                  }, {
                    'children': [],
                    'moduleIcon': 'bannerManage',
                    'moduleName': 'Banner管理',
                    'moduleUrl': '/marketingManage/bannerManage',
                  }, {
                    'children': [],
                    'moduleIcon': 'thematicActivitiesManage',
                    'moduleName': '主题活动管理',
                    'moduleUrl': '/marketingManage/thematicActivitiesManage',
                  }],
                'commonSort': '40',
                'moduleIcon': 'icon-yingxiaoguanli',
                'moduleName': '营销管理',
                'moduleUrl': '/marketingManage',
              }, {
                'children': [{
                  'children': [],
                  'moduleIcon': 'copywriting',
                  'moduleName': '文案设置',
                  'moduleUrl': '/system_manage/copywriting',
                }, {
                  'children': [],
                  'moduleIcon': '1',
                  'moduleName': '帮助中心',
                  'moduleUrl': '/system_manage/help_center',
                }, {
                  'children': [],
                  'moduleIcon': 'icon-notice',
                  'moduleName': '公告通知',
                  'moduleUrl': '/system_manage/notice',
                }, {
                  'children': [],
                  'moduleIcon': 'version_manage',
                  'moduleName': '版本管理',
                  'moduleUrl': '/system_manage/version_manage',
                }],
                'moduleIcon': 'icon-peizhiguanli',
                'moduleName': '配置管理',
                'moduleUrl': '/config',
              }, {
                'children': [{
                  'children': [],
                  'moduleIcon': '1',
                  'moduleName': '验证管理',
                  'moduleUrl': '/system_manage/test_manage',
                }, {
                  'children': [],
                  'moduleIcon': 'version_manage',
                  'moduleName': '账号管理',
                  'moduleUrl': '/system_manage/accountManage',
                }, {
                  'children': [],
                  'moduleIcon': 'copywriting',
                  'moduleName': '角色管理',
                  'moduleUrl': '/system_manage/role_manage',
                }, {
                  'children': [],
                  'moduleIcon': 'login_log',
                  'moduleName': '登录日志',
                  'moduleUrl': '/system_manage/login_log',
                }, {
                  'children': [],
                  'moduleIcon': 'login_log',
                  'moduleName': '菜单权限',
                  'moduleUrl': '/system_manage/menu_auth_manage',
                }],
                'moduleIcon': 'icon-yanzheng',
                'moduleName': '系统管理',
                'moduleUrl': '/system_manage',
              }
            ],*/
        isCollapse: false
      }
    },
    methods: {
      goPath (group, item) {
        if (item.moduleUrl === this.$route.path) {
          this.refresh()
        }
        this.$router.push(item.moduleUrl)
      },
      //获取动态菜单 //user/login/getUserMenuList
      getMenu () {
        this.jsonData = JSON.parse(localStorage.getItem('menu_list')) || [];
        this.defaultActive = this.oldToNewPath();
        // this.defaultActive = this.$route.path
      },
      // 菜单转换
      oldToNewPath() {
        const resetActives = {
          '/base_data/new_category_manage': '/base_data/category_manage',
          '/base_data/new_size_manage': '/base_data/size_manage',
          '/shop_manage/new_merchant_manage': '/shop_manage/merchant_manage',
          '/shop_manage/new_store_manage': '/shop_manage/store_manage'
        };
        return Object.keys(resetActives).includes(this.$route.path) ? resetActives[this.$route.path] : this.$route.path;
      }
    },
    components: {},
    mounted () {
      this.getMenu()
    },
    watch: {
      '$route' () {
        this.$nextTick(() => {
          this.defaultActive = this.oldToNewPath();
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .icon-path {
    color: #333333;
    margin-right: 6px;
    font-size: 18px;
  }

  #left {
    float: left;
    position: relative;
    width: 180px !important;
    height: 100%;
    padding-top: 20px;
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.08);

    .el-menu {
      border-top: 1px solid #e5e5e5;
      border-right: 0;

      .no-child {
        /*padding-left: 30px !important;*/
        text-align: left;
        color: #333;
        border-bottom: 1px solid #e5e5e5;

        &.is-active {
          background-color: #537fb7;
          color: #fff;
        }
      }

      .el-submenu {
        /*border-top: 1px solid #e5e5e5;*/
        border-bottom: 1px solid #e5e5e5;

        .el-menu-item {
          min-width: 180px;
          height: 40px;
          line-height: 40px;
          padding-left: 54px !important;

          &:focus {
            background-color: #edeff1;
          }

          &:hover {
            background-color: #edeff1;
          }
        }
      }

      .el-menu--inline {
        li {
          color: #666;
          text-align: left;

          &.is-active {
            color: #537fb7;
            background-color: #edeff1;
          }
        }
      }

      /*      /deep/ .el-menu-item, /deep/ .el-submenu__title {
              height: 50px;
              line-height: 50px;
            }
            /deep/ .el-submenu {
              .el-submenu__title {
                padding-left: 20px !important;
                text-align: left;
                color: #333;
                &:hover {
                  background-color: #edeff1;
                }
              }
            }*/
    }
  }
</style>
<style scoped>
  .el-menu >>> .el-menu-item,
  .el-menu >>> .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }

  /*二级样式*/
  .el-submenu >>> .el-submenu__title {
    padding-left: 20px !important;
    text-align: left;
    color: #333;
  }

  .el-submenu >>> .el-submenu__title:hover {
    background-color: #edeff1;
  }

  .el-submenu.is-opened >>> .el-submenu__title {
    background-color: #edeff1;
  }

  .el-submenu.is-active >>> .el-submenu__title .moduleIcon-class {
    color: #fff;
  }

  .el-submenu.is-active >>> .el-submenu__title i {
    color: #fff;
  }

  .el-submenu.is-active >>> .el-submenu__title {
    color: #fff;
    background-color: #537fb7;
  }
</style>



// WEBPACK FOOTER //
// src/page/layout/left_side.vue